import React from "react";

const ILock = ({
  color = "#101010",
  width = "24",
  height = "24",
  ...props
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        d="M11.999 15C13.0346 15 13.874 14.1605 13.874 13.125C13.874 12.0895 13.0346 11.25 11.999 11.25C10.9635 11.25 10.124 12.0895 10.124 13.125C10.124 14.1605 10.9635 15 11.999 15Z"
        stroke={color}
        stroke-width="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.999 15V17.25"
        stroke={color}
        stroke-width="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.499 8.25H4.49902C4.08481 8.25 3.74902 8.58579 3.74902 9V19.5C3.74902 19.9142 4.08481 20.25 4.49902 20.25H19.499C19.9132 20.25 20.249 19.9142 20.249 19.5V9C20.249 8.58579 19.9132 8.25 19.499 8.25Z"
        stroke={color}
        stroke-width="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.62402 8.25V4.875C8.62402 3.97989 8.9796 3.12145 9.61254 2.48851C10.2455 1.85558 11.1039 1.5 11.999 1.5C12.8941 1.5 13.7526 1.85558 14.3855 2.48851C15.0184 3.12145 15.374 3.97989 15.374 4.875V8.25"
        stroke={color}
        stroke-width="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ILock;
